import {
  COMMENT_REPLY_SET,
  COMMENT_REPLY_CANCEL
} from "app/redux/constants/actionTypes";

const initialState = {};
export default function commentReply(state = initialState, action) {
  if (action.type === COMMENT_REPLY_SET) {
    return { ...state, ...action.values };
  }
  if (action.type === COMMENT_REPLY_CANCEL) {
    return {};
  }
  return state;
}
